// extracted by mini-css-extract-plugin
module.exports = {"detailButtonWrapper":"AccordionList_detailButtonWrapper__X0MJU","icon":"AccordionList_icon__A918Y","iconRotate":"AccordionList_iconRotate__BcIuC"};